import React from 'react';
import {Link} from "react-router-dom";

export class HeaderMenu extends React.Component {
    render() {
        return (
            <>
                <div className="nav-term-wrapper">
                    <ul className="nav-term">
                        <li className="nav-term__item_main">
                            <a href="/commercial">Коммерческие условия</a>
                            <svg className="__narrow-down-nav-term" width="14" height="8"
                                 viewBox="0 0 14 8" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M7.71 7.71L13.71 1.71C13.89 1.53 14 1.28 14 1C14 0.45 13.55 -1.96701e-08 13 -4.37114e-08C12.72 -5.59506e-08 12.47 0.11 12.29 0.29L7 5.59L1.71 0.3C1.53 0.11 1.28 -5.56009e-07 1 -5.68248e-07C0.45 -5.92289e-07 -1.96701e-08 0.449999 -4.37114e-08 0.999999C-5.59506e-08 1.28 0.110001 1.53 0.290001 1.71L6.29 7.71C6.47 7.89 6.72 8 7 8C7.28 8 7.53 7.89 7.71 7.71Z"
                                      fill="#838E9A"/>
                            </svg>
                            <ul>
                                <li className="nav-term__item">
                                    <Link to="/commercial#1">Условия оплаты</Link>
                                </li>
                                <li className="nav-term__item">
                                    <Link to={'/commercial#2'}>Скидки</Link>
                                </li>
                                <li className="nav-term__item">
                                    <Link to={'/commercial#3'}>Торговые премии</Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </>
        );
    }
}


